var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homapt-button-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col text-center"},[_c('p',{staticClass:"homapt-social-button-text"},[_vm._v(_vm._s(_vm.buttonText))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-763d951c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/authentication/HomAptButton.vue
// module id = null
// module chunks = 